import { WIDGET_TYPES } from 'enums/configuration';

export default function applyDefaultConfiguration(config) {
  return Object.assign({}, config, getDeveloperValues(config), getConfiguration(window.gladlyConfig, config));
}

function getDeveloperValues(config = {}) {
  const windowAppId = window.gladlyConfig ? window.gladlyConfig.appId : config.appId;
  if (process.env.NODE_ENV === 'development' && windowAppId === 'TO_BE_FILLED_IN') {
    return {
      appId: process.env.REACT_APP_SMOOCH_APP_ID,
    };
  }

  return {};
}

function getConfiguration(windowConfig = {}, config) {
  return {
    amplitudeApiKey: process.env.REACT_APP_AMPLITUDE_API_KEY,
    cluster: windowConfig.cluster || 'production',
    environment: windowConfig.environment || 'production',
    widgetType: windowConfig.widgetType || WIDGET_TYPES.CHAT,
    sentryDSN: process.env.REACT_APP_SENTRY_DSN,
    cdn:
      // if config.gladlyCdn exisits use that, else check for window configuration and use,
      // else parse from the cdn provided to the v2 loader (or the loader default),
      // otherwise default to 'https://cdn.gladly.com' for v1 loader
      config.gladlyCdn || windowConfig.gladlyCdn || getTrimmedLoaderCdn(config.loaderCdn) || 'https://cdn.gladly.com',
  };
}

function getTrimmedLoaderCdn(loaderCdn) {
  // First RegEx finds everything up to and including the first double slashes "//" ex. https://
  // Second RegEx finds the first single slash "/" and everything that follows ex. /path/path.js
  // Add protocol and double slash back at the end
  // ex. https://hello.gladly.qa/mert/mert returns https://hello.gladly.qa
  if (loaderCdn) {
    let protocol = loaderCdn.match(/(.*)\/\//);
    if (protocol) {
      return protocol[0] + loaderCdn.replace(/(.*)\/\//, '').replace(/\/(?!\/)(.*)/, '');
    }
  }
}
